import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Home = createReactComponent("Home", ["svg", defaultAttributes, [["path", {
  d: "M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z",
  key: "s0qlbv"
}], ["polyline", {
  points: "9 22 9 12 15 12 15 22",
  key: "9mql8z"
}]]]);
export default Home;